import { DateField } from "components/DesignSystem/DateInput/DateField";
import { FormikForm } from "components/FormikForm/FormikForm";
import { YYYY_MM_DD } from "constants/date";
import dayjs from "dayjs";
import { Form } from "formik";
import { useModal } from "hooks/useModal";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useToast } from "hooks/useToast";
import {
  useUpdateTaskAssigneeAdminMutation,
  useUpdateTaskAssigneeProviderMutation,
} from "store/apis/serviceTeam";
import { Task } from "types/Models/task";
import { BackendError } from "types/utils/error";

type TaskDeadlineProps = {
  rowData: Task;
};

export const AddTaskDeadline = ({ rowData }: TaskDeadlineProps) => {
  const { alertToast, successToast } = useToast();
  const deadlineUpdateModal = useModal();
  const [updateTaskDeliveryTimeAdmin] = useUpdateTaskAssigneeAdminMutation();
  const [updateTaskDeliveryTime] = useUpdateTaskAssigneeProviderMutation();
  const { isAdmin } = useRoleBasedView();
  const confirmUpdateModal = useModal();

  let updateTaskAssignee = isAdmin
    ? updateTaskDeliveryTimeAdmin
    : updateTaskDeliveryTime;

  const handleSubmit = async (deadline: Date) => {
    try {
      if (!deadline) {
        alertToast({ message: "Please select a valid date" });
        return;
      }
      await updateTaskAssignee({
        taskId: rowData.uuid,
        deadline_date: dayjs(deadline).format(YYYY_MM_DD),
      }).unwrap();
      successToast({ message: "Deadline updated successfully" });
      deadlineUpdateModal.close();
      confirmUpdateModal.close();
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  return (
    <FormikForm
      initialValues={{ deadline: "" }}
      validationSchema={null}
      onSubmit={() => {}}
    >
      <DateField
        name="deadline"
        dateProps={{
          onDateChange: (date: Date) => handleSubmit(date),
        }}
      />
    </FormikForm>
  );
};
